import { useState, useEffect } from 'react';
import { Modal, Badge } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { obtenerBloqueo } from '../../actions/citas';

const DetallesBloqueo = ({ bloqueo, reestablecerBloqueo, editarBloqueo, eliminarBloqueo }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.citas);

    const [detallesModal, setDetallesModal] = useState(false);

    const [bloqueoData, setBloqueoData] = useState({
        id: null,
        locatario: null,
        motivo: null, 
        fecha_inicio: null,
        fecha_fin: null, 
        status: 1
    });

    const handleAbrir = () => {
        dispatch(obtenerBloqueo(bloqueo?.id));
    }

    const handleCerrar = () => {
        setBloqueoData({
            id: null,
            locatario: null,
            motivo: null, 
            fecha_inicio: null,
            fecha_fin: null, 
            status: 1
        });

        setDetallesModal(false);
        reestablecerBloqueo(null);
    }
    
    /* Editar bloqueo */
    const handleEditar = () => {
        handleCerrar();
        editarBloqueo(bloqueoData);
    }

    /* Eliminar bloqueo */
    const handleEliminar = () => {
        handleCerrar();
        eliminarBloqueo(bloqueoData);
    }

    /* Funciones generales */
    const getRangoFechas = (inicio, fin) => {
        if(inicio == fin){
            return 'Unicamente el ' + (new Date(inicio).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }))
        }else{
            return 'Del ' + (new Date(inicio).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })) + ' al ' + (new Date(fin).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }))
        }
    }

    useEffect(() => {
        dispatch(obtenerBloqueo(null));
    }, []);

    useEffect(() => {
        if(bloqueo){
            setDetallesModal(true);
            
            dispatch(obtenerBloqueo(bloqueo?.id));

            setBloqueoData({
                ...bloqueoData,
                id: bloqueo?.id
            });
        }
    }, [bloqueo]);

    useEffect(() => {
        if(detalles){
            setBloqueoData({
                ...bloqueoData,
                id: detalles?._id, 
                locatario: detalles?.locatario,
                motivo: detalles?.motivo, 
                fecha_inicio: detalles?.fecha_inicio,
                fecha_fin: detalles?.fecha_fin, 
                status: 1
            });
        }
    }, [detalles]);

    return (
        <Modal show={detallesModal} backdrop="static" size="md" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Bloqueo de disponibilidad</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12">
                        <label className="fw-bold">Periodo</label>
                        <p>{ getRangoFechas(bloqueoData?.fecha_inicio, bloqueoData?.fecha_fin) }</p>
                    </div>

                    <div className="col-md-6">
                        <label className="fw-bold">Locatario</label>
                        <p>{bloqueoData?.locatario?.nombre}</p>
                    </div>

                    <div className="col-md-6">
                        <label className="fw-bold">Servicio</label>
                        <p>{bloqueoData?.locatario?.servicio?.nombre || 'Sin definir'}</p>
                    </div>

                    <div className="col-md-12">
                        <label className="fw-bold">Motivo</label>
                        <p>{bloqueoData?.motivo}</p>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-warning" onClick={() => handleEditar()}><i className="fas fa-pencil fa-sm"></i> Editar</button>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleEliminar()}><i className="fas fa-trash fa-sm"></i> Eliminar</button>
            </Modal.Footer>
        </Modal>
    )
}

export default DetallesBloqueo;